export const DEFAULT_BRAND_ID = '5ba255397a6c8a7d309a72c1'